module.exports = __webpack_public_path__ + "media/homepage/scholarships-d6b2b90f.webp";